import { formatDateTimeBr } from '@/shared/lib/utils/dateTimeBr';
import type { VersaoApiResponse } from '@/types/api';

export type VersaoWeb = {
  versao: string;
  commit: string;
  buildEm: string;
};

/** Valores injetados pelo vite.config.ts; vazios no vitest. */
export function obterVersaoWeb(): VersaoWeb {
  return {
    versao: import.meta.env.VITE_APP_VERSION ?? '',
    commit: import.meta.env.VITE_APP_COMMIT ?? '',
    buildEm: import.meta.env.VITE_APP_BUILD_TIME ?? '',
  };
}

export type TelaUsuario = {
  tela: string;
  janela: string;
  escala: string;
};

/** Resolucao do monitor, area util do navegador e escala (zoom do sistema). */
export function obterTela(): TelaUsuario {
  const escala = Math.round(window.devicePixelRatio * 100);
  return {
    tela: `${window.screen.width} × ${window.screen.height}`,
    janela: `${window.innerWidth} × ${window.innerHeight}`,
    escala: `${escala}%`,
  };
}

export function commitCurto(commit: string | null | undefined): string {
  return commit ? commit.slice(0, 7) : '—';
}

/** Instantes da API e da build vem em UTC (com Z), nao em horario de parede. */
export function formatarInstante(iso: string | null | undefined): string {
  if (!iso) return '—';
  const data = new Date(iso);
  return Number.isNaN(data.getTime()) ? '—' : formatDateTimeBr(data);
}

/** Texto para colar num chamado: commits completos, sem dado pessoal. */
export function textoParaCopiar(
  produto: string,
  web: VersaoWeb,
  api: VersaoApiResponse | undefined,
  tela?: TelaUsuario,
): string {
  const linhas = [
    `${produto} ${web.versao || '—'}`,
    `Web commit: ${web.commit || '—'}`,
    `Web build: ${formatarInstante(web.buildEm)}`,
  ];
  if (tela) {
    linhas.push(`Tela: ${tela.tela} | Janela: ${tela.janela} | Escala: ${tela.escala}`);
  }
  if (api) {
    linhas.push(
      `API ${api.versao ?? '—'} (${api.perfis.join(', ') || '—'})`,
      `API commit: ${api.commit ?? '—'}`,
      `API build: ${formatarInstante(api.buildEm)}`,
      `API no ar desde: ${formatarInstante(api.iniciadaEm)}`,
    );
  } else {
    linhas.push('API: indisponivel');
  }
  return linhas.join('\n');
}
